/* eslint-disable no-continue */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import Cell from '../Cell';

import styles from './styles.module.css';

const alphabet = 'abcdefghijklmnopqrstxyuvz';

const Squares = ({ userData, receive, size, answers, selectedCells, isSubmitted, onCellClick: onCellClickProps }) => {
  // const columns = [];
  const randomNumber = React.useCallback((minNumber = 0, maxNumber = 1) => Math.floor(Math.random() * (maxNumber - minNumber + 1)) + minNumber, []);

  // random text
  const randomCharacters = React.useCallback((length) => {
    let result = '';
    const charactersLength = alphabet.length;
    for (let i = 0; i < length; i++) {
      result += alphabet.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }, []);

  const generateCorrectRowOrColumn = React.useCallback(
    (answer, exceptSize = 0, random = randomNumber(0, 1)) => {
      let result = [];

      // const random = randomNumber(0, 1);
      const remain = size - answer.length - exceptSize;

      let randomItems = [];

      const correctItems = answer.split('').map((text) => ({ text, correct: true }));

      if (remain > 0) {
        randomItems = randomCharacters(remain)
          .split('')
          .map((text) => ({ text, correct: false }));
      }

      result = random ? randomItems.concat(correctItems) : correctItems.concat(randomItems);

      return result;
    },
    [randomNumber, size, randomCharacters],
  );

  const correctRow1Index = React.useMemo(() => randomNumber(1, size / 2), [randomNumber, size]);

  const correctRow2Index = React.useMemo(() => randomNumber(size / 2 + 1, size), [randomNumber, size]);

  const correctColumnIndex = React.useMemo(() => randomNumber(0, 1), [randomNumber]);

  // kiểm tra và thêm vào đủ 6 kí tự answer 1
  const correctAnswerRow1 = React.useMemo(() => generateCorrectRowOrColumn(answers[0].answer, 1, correctColumnIndex), [answers, generateCorrectRowOrColumn, correctColumnIndex]);
  // kiểm tra và thêm vào đủ 6 kí tự answer 2
  const correctAnswerRow2 = React.useMemo(() => generateCorrectRowOrColumn(answers[1].answer, 1, correctColumnIndex), [answers, generateCorrectRowOrColumn, correctColumnIndex]);
  // kiểm tra và thêm vào đủ 6 kí tự answer 3
  const correctAnswerColumn = React.useMemo(() => generateCorrectRowOrColumn(answers[2].answer), [answers, generateCorrectRowOrColumn]);

  // text random row1
  const textRandom1 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row6
  const textRandom2 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row3
  const textRandom3 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row6
  const textRandom4 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row5
  const textRandom5 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row6
  const textRandom6 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row7
  const textRandom7 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  // text random row8
  const textRandom8 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const textRandom9 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const textRandom10 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const textRandom11 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const textRandom12 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const textRandom13 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const textRandom14 = React.useMemo(() => {
    return randomCharacters(size)
      .split('')
      .map((item) => ({ text: item }));
  }, [randomCharacters, size]);

  const onCellClick = React.useCallback(
    (row, cell, cellItem) => (text) => {
      onCellClickProps?.(row, cell, cellItem);
    },
    [onCellClickProps],
  );

  const push = React.useCallback((cells) => {
    receive(cells);
  }, [receive]);

  const renderColumn = React.useCallback(
    (_, index) => {
      const cells = {
        1: correctAnswerColumn[0],
        2: correctAnswerColumn[1],
        3: correctAnswerColumn[2],
        4: correctAnswerColumn[3],
        5: correctAnswerColumn[4],
        6: correctAnswerColumn[5],
        7: correctAnswerColumn[6],
        8: correctAnswerColumn[7],
        9: correctAnswerColumn[8],
        10: correctAnswerColumn[9],
        11: correctAnswerColumn[10],
        12: correctAnswerColumn[11],
        13: correctAnswerColumn[12],
        14: correctAnswerColumn[13],
      };

      // correctColumnIndex = 1 => right
      // correctColumnIndex = 0 => left
      const isLeft = !correctColumnIndex && index > 0;

      if ((correctColumnIndex && index < size - 1) || isLeft) {
        let currentIndex = index;

        if (isLeft) {
          currentIndex -= 1;
        }

        // ---- First correct word loop
        cells[correctRow1Index] = correctAnswerRow1[currentIndex];

        let randomTextList = [textRandom1[currentIndex], textRandom2[currentIndex], textRandom3[currentIndex], textRandom4[currentIndex], textRandom5[currentIndex], textRandom6[currentIndex], textRandom7[currentIndex]];

        for (let i = 1; i <= size / 2; i++) {
          if (i === correctRow1Index) continue;

          cells[i] = randomTextList[0];
          randomTextList.splice(0, 1);
        }

        // ---- Second correct word loop
        cells[correctRow2Index] = correctAnswerRow2[currentIndex];
        randomTextList = [textRandom8[currentIndex], textRandom9[currentIndex], textRandom10[currentIndex], textRandom11[currentIndex], textRandom12[currentIndex], textRandom13[currentIndex], textRandom14[currentIndex]];

        for (let i = size / 2 + 1; i <= size; i++) {
          if (i === correctRow2Index) continue;

          cells[i] = randomTextList[0];
          randomTextList.splice(0, 1);
        }
      }
      push(cells);
      return (
        <div key={index}>
          {Array(size)
            .fill()
            .map((cellItem, cellIndex) => {
              const key = cellIndex + 1;
              const selected = selectedCells.find((x) => x.position.row === index && x.position.cell === key);
              return <Cell key={cellIndex} selected={!!selected} isSubmitted={isSubmitted} correct={selected?.correct} text={cells[key]?.text} onClick={onCellClick(index, key, cells[key])} />;
            })}
        </div>
      );
    },
    [
      push,
      correctAnswerColumn,
      correctColumnIndex,
      size,
      correctRow1Index,
      correctAnswerRow1,
      textRandom1,
      textRandom2,
      textRandom3,
      textRandom4,
      textRandom5,
      textRandom6,
      textRandom7,
      correctRow2Index,
      correctAnswerRow2,
      textRandom8,
      textRandom9,
      textRandom10,
      textRandom11,
      textRandom12,
      textRandom13,
      textRandom14,
      selectedCells,
      isSubmitted,
      onCellClick,
    ],
  );

  const renderColumnWithUserData = (cells, index) => {
    push(cells);
    return (
      <div key={index}>
        {Array(size)
          .fill()
          .map((cellItem, cellIndex) => {
            const key = cellIndex + 1;
            const selected = selectedCells.find((x) => x.position.row === index && x.position.cell === key);
            return <Cell key={cellIndex} selected={!!selected} isSubmitted={isSubmitted} correct={selected?.correct} text={cells[key]?.text} onClick={onCellClick(index, key, cells[key])} />;
          })}
      </div>
    );
  };

  return (
    <div className={styles.square}>
      {
        userData ? userData.map(renderColumnWithUserData) :
          Array(size).fill().map(renderColumn)
      }
    </div>
  );
};

Squares.propTypes = {
  size: PropTypes.number.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  answers: PropTypes.instanceOf(Array).isRequired,
  selectedCells: PropTypes.instanceOf(Array).isRequired,
  onCellClick: PropTypes.func.isRequired,
};

export default Squares;
